import { VerticalNavMessagePageTemplate } from '@/components/templates/VerticalNavMessagePageTemplate'
import { DEFAULT_NFTS_PAGE_HEADER_IMAGE_PATH } from '@/constants'
import { GetStaticProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { observer } from 'mobx-react'
import { sanitizeUrl } from '@/utils'
import styles from './index.module.scss'

// declare global {
//   interface Window {
//     ownerId: string
//     collectionId: string
//   }
// }

const CitizenshipNFTs: NextPage = observer(() => {
  // useEffect(() => {
  //   // ページ遷移時 mint ボタンが表示されないため、ownerId がある場合はリロードする
  //   if (!window.ownerId || !window.collectionId) {
  //     window.ownerId = '7q3iocvyap75RoR7rwB9bhCU7XHSqnqEppsF86xMuyGT'
  //     window.collectionId = 'df5T1gULGMBcg7RqEWym'
  //   } else {
  //     window.location.reload()
  //   }
  // }, [])

  return (
    // TODO: fetch の indicator が必要
    // TODO: ログインしていない場合はログインを促す。ページは表示できていい。
    <VerticalNavMessagePageTemplate>
      {/* <MyHead title='Buy AQA Citizenship Nfts'>
        <script type='module' src='https://storage.googleapis.com/scriptslmt/0.1.3/solana.js' />
        <link rel='stylesheet' href='https://storage.googleapis.com/scriptslmt/0.1.3/solana.css' />
      </MyHead> */}
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerContainer}>
            <img src={DEFAULT_NFTS_PAGE_HEADER_IMAGE_PATH} alt='Header' className={styles.headerImage} />
            <div className={styles.headerContent}>
              <figure className={styles.headerLogo}>
                <img src='/images/common/nft_logo.png' alt='nft_logo' className='img-fluid' />
              </figure>
              <div>
                <p className={styles.headerTitle}>AQA Citizenship NFT</p>
                <p className={styles.headerDescription}>AQA Digital City Citizenship NFT.</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.mint}>
            <figure className={styles.figure}>
              <img src='/images/common/citizenship_nft_classic.png' alt='Classic' className='img-fluid' />
            </figure>
            <div className={styles.mintContainer}>
              <p className={styles.name}>AQA Digital ID - Classic</p>
              <div className={styles.mintInfo}>
                <p className={styles.mintPrice}>Price: 1 SOL</p>
                {/* <div className={styles.mintCounter}>
                  <span>Mint Count:&nbsp;</span>
                  <div id='mint-counter' />
                </div> */}
              </div>
              {/* <div className={styles.mintButton}>
                <div id='mint-button-container' />
              </div>
              <div id="slider-container" className={styles.sliderContainer}>
                <span id="mint-slider" style={{ width: '200px' }}></span>
                <span id="mint-slider-amount" className={styles.sliderAmount}></span>
              </div> */}
              <div className={styles.linkContainer}>
                <a
                  href={sanitizeUrl(
                    'https://launchmynft.io/collections/7q3iocvyap75RoR7rwB9bhCU7XHSqnqEppsF86xMuyGT/df5T1gULGMBcg7RqEWym'
                  )}
                  className={styles.link}
                  target='_blank'
                  rel='nofollow noopener noreferrer'
                >
                  Mint with LaunchMyNFT.io
                </a>
              </div>
            </div>
          </div>

          <div className={styles.mint}>
            <figure className={styles.figure}>
              <img src='/images/common/citizenship_nft_platinum.png' alt='Platinum' className='img-fluid' />
            </figure>
            <div className={styles.mintContainer}>
              <p className={styles.name}>AQA Digital ID - Platinum</p>
              <div className={styles.linkContainer}>
                <p className={styles.text}>Coming soon</p>
              </div>
            </div>
          </div>

          <div className={styles.mint}>
            <figure className={styles.figure}>
              <img src='/images/common/citizenship_nft_diamond.png' alt='Diamond' className='img-fluid' />
            </figure>
            <div className={styles.mintContainer}>
              <p className={styles.name}>AQA Digital ID - Diamond</p>
              <div className={styles.linkContainer}>
                <p className={styles.text}>Coming soon</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VerticalNavMessagePageTemplate>
  )
})

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['global', 'm', 'companies-users-[id]'])),
    },
  }
}

export default CitizenshipNFTs
